import { createPubSub } from '@/helpers/pubSub';

export const variablesBus = createPubSub();

// events
export const ON_MAPPING_VARIABLES = 'OnMappingVariables';
